export const questionCollection = [
  {
    text: 'At a party do you: ',
    answers: [
      {
        letter: 'A',
        text: 'Interact with many, including strangers',
        answerKey: 'E',
      },
      { letter: 'B', text: 'Interact with a few, known to you', answerKey: 'I' },
    ],
  },
  {
    text: 'Are you more: ',
    answers: [
      {
        letter: 'A',
        text: 'Realistic',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Philosophically inclined', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you more intrigued by: ',
    answers: [
      {
        letter: 'A',
        text: 'Facts',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Comparing similarities', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you usually more: ',
    answers: [
      {
        letter: 'A',
        text: 'Fair minded',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Kind hearted', answerKey: 'F' },
    ],
  },
  {
    text: 'Do you tend to be more: ',
    answers: [
      {
        letter: 'A',
        text: 'Dispassionate',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Sympathetic', answerKey: 'F' },
    ],
  },
  {
    text: 'Do you prefer to work: ',
    answers: [
      {
        letter: 'A',
        text: 'To deadlines',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Just "whenever"', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you tend to choose: ',
    answers: [
      {
        letter: 'A',
        text: 'Rather carefully',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Somewhat impulsively', answerKey: 'P' },
    ],
  },
  {
    text: 'At parties do you: ',
    answers: [
      {
        letter: 'A',
        text: 'Stay late, with increasing energy',
        answerKey: 'E',
      },
      { letter: 'B', text: 'Leave early, with decreasing energy', answerKey: 'I' },
    ],
  },
  {
    text: 'Are you a more: ',
    answers: [
      {
        letter: 'A',
        text: 'Sensible person',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Reflective person', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you more drawn to: ',
    answers: [
      {
        letter: 'A',
        text: 'Hard data',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Complicated ideas', answerKey: 'N' },
    ],
  },
  {
    text: 'Is it more natural to you to be: ',
    answers: [
      {
        letter: 'A',
        text: 'Fair to others',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Nice to others', answerKey: 'F' },
    ],
  },
  {
    text: 'In first approaching others are you more: ',
    answers: [
      {
        letter: 'A',
        text: 'Impersonal and detached',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Personal and engaging', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you usually more: ',
    answers: [
      {
        letter: 'A',
        text: 'Punctual',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Leisurely', answerKey: 'P' },
    ],
  },
  {
    text: 'Does it bother you more having things: ',
    answers: [
      {
        letter: 'A',
        text: 'Incomplete',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Completed', answerKey: 'P' },
    ],
  },
  {
    text: 'In your social groups do you: ',
    answers: [
      {
        letter: 'A',
        text: "Keep abreast of others' happenings",
        answerKey: 'E',
      },
      { letter: 'B', text: 'Get behind on the news', answerKey: 'I' },
    ],
  },
  {
    text: 'Are you usually more interested in: ',
    answers: [
      {
        letter: 'A',
        text: 'Specifics',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Concepts', answerKey: 'N' },
    ],
  },
  {
    text: 'Do you prefer writers who: ',
    answers: [
      {
        letter: 'A',
        text: 'Say what they mean',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Use lots of analogies', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you more naturally: ',
    answers: [
      {
        letter: 'A',
        text: 'Impartial',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Compassionate', answerKey: 'F' },
    ],
  },
  {
    text: 'In judging are you more likely to be: ',
    answers: [
      {
        letter: 'A',
        text: 'Impersonal',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Sentimental', answerKey: 'F' },
    ],
  },
  {
    text: 'Do you usually: ',
    answers: [
      {
        letter: 'A',
        text: 'Settle things',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Keep options open', answerKey: 'P' },
    ],
  },
  {
    text: 'Are you usually rather: ',
    answers: [
      {
        letter: 'A',
        text: 'Quick to agree to a time',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Reluctant to agree to a time', answerKey: 'P' },
    ],
  },
  {
    text: 'In phoning do you: ',
    answers: [
      {
        letter: 'A',
        text: 'Just start talking',
        answerKey: 'E',
      },
      { letter: 'B', text: "Rehearse what you'll say", answerKey: 'I' },
    ],
  },
  {
    text: 'Facts: ',
    answers: [
      {
        letter: 'A',
        text: 'Speak for themselves',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Usually require interpretation', answerKey: 'N' },
    ],
  },
  {
    text: 'Do you prefer to work with: ',
    answers: [
      {
        letter: 'A',
        text: 'Practical information',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Abstract ideas', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you inclined to be more: ',
    answers: [
      {
        letter: 'A',
        text: 'Cool headed',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Warm hearted', answerKey: 'F' },
    ],
  },
  {
    text: 'Would you rather be: ',
    answers: [
      {
        letter: 'A',
        text: 'More just than merciful',
        answerKey: 'T',
      },
      { letter: 'B', text: 'More merciful than just', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you more comfortable: ',
    answers: [
      {
        letter: 'A',
        text: 'Setting a schedule',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Putting things off', answerKey: 'P' },
    ],
  },
  {
    text: 'Are you more comfortable with: ',
    answers: [
      {
        letter: 'A',
        text: 'Written agreements',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Handshake agreements', answerKey: 'P' },
    ],
  },
  {
    text: 'In company do you: ',
    answers: [
      {
        letter: 'A',
        text: 'Start conversations',
        answerKey: 'E',
      },
      { letter: 'B', text: 'Wait to be approached', answerKey: 'I' },
    ],
  },
  {
    text: 'Traditional common sense is: ',
    answers: [
      {
        letter: 'A',
        text: 'Usually trustworthy',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Often misleading', answerKey: 'N' },
    ],
  },
  {
    text: 'Children often do not: ',
    answers: [
      {
        letter: 'A',
        text: 'Make themselves useful enough',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Daydream enough', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you usually more: ',
    answers: [
      {
        letter: 'A',
        text: 'Tough minded',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Tender hearted', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you more: ',
    answers: [
      {
        letter: 'A',
        text: 'Firm than gentle',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Gentle than firm', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you more prone to keep things: ',
    answers: [
      {
        letter: 'A',
        text: 'Well organised',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Open ended', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you put more value on the: ',
    answers: [
      {
        letter: 'A',
        text: 'Definite',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Variable', answerKey: 'P' },
    ],
  },
  {
    text: 'Does new interaction with others: ',
    answers: [
      {
        letter: 'A',
        text: 'Stimulate and energise you',
        answerKey: 'E',
      },
      { letter: 'B', text: 'Tax your reserves', answerKey: 'I' },
    ],
  },
  {
    text: 'Are you more frequently: ',
    answers: [
      {
        letter: 'A',
        text: 'A practical sort of person',
        answerKey: 'S',
      },
      { letter: 'B', text: 'An abstract sort of person', answerKey: 'N' },
    ],
  },
  {
    text: 'Which are you drawn to: ',
    answers: [
      {
        letter: 'A',
        text: 'Accurate perception',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Concept formation', answerKey: 'N' },
    ],
  },
  {
    text: 'Which is more satisfying: ',
    answers: [
      {
        letter: 'A',
        text: 'To discuss an issue thoroughly',
        answerKey: 'T',
      },
      { letter: 'B', text: 'To arrive at an agreement on an issue', answerKey: 'F' },
    ],
  },
  {
    text: 'Which rules you more: ',
    answers: [
      {
        letter: 'A',
        text: 'Your head',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Your heart', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you more comfortable with work: ',
    answers: [
      {
        letter: 'A',
        text: 'Contracted',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Done on a casual basis', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you prefer things to be: ',
    answers: [
      {
        letter: 'A',
        text: 'Neat and orderly',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Optional', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you prefer: ',
    answers: [
      {
        letter: 'A',
        text: 'Many friends with brief contact',
        answerKey: 'E',
      },
      { letter: 'B', text: 'A few friends with longer contact', answerKey: 'I' },
    ],
  },
  {
    text: 'Are you more drawn to: ',
    answers: [
      {
        letter: 'A',
        text: 'Substantial information',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Credible assumptions', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you more interested in: ',
    answers: [
      {
        letter: 'A',
        text: 'Production',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Research', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you more comfortable when you are: ',
    answers: [
      {
        letter: 'A',
        text: 'Objective',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Personal', answerKey: 'F' },
    ],
  },
  {
    text: 'Do you value in yourself more than you are: ',
    answers: [
      {
        letter: 'A',
        text: 'Unwaivering',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Devoted', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you more comfortable with: ',
    answers: [
      {
        letter: 'A',
        text: 'Final statements',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Tentative statements', answerKey: 'P' },
    ],
  },
  {
    text: 'Are you more comfortable: ',
    answers: [
      {
        letter: 'A',
        text: 'After a decision',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Before a decision', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you: ',
    answers: [
      {
        letter: 'A',
        text: 'Speak easily and at length with strangers',
        answerKey: 'E',
      },
      { letter: 'B', text: 'Find little to say to strangers', answerKey: 'I' },
    ],
  },
  {
    text: 'Are you usually more interested in the: ',
    answers: [
      {
        letter: 'A',
        text: 'Particular instance',
        answerKey: 'S',
      },
      { letter: 'B', text: 'General case', answerKey: 'N' },
    ],
  },
  {
    text: 'Do you feel: ',
    answers: [
      {
        letter: 'A',
        text: 'More practical than ingenious',
        answerKey: 'S',
      },
      { letter: 'B', text: 'More ingenious than practical', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you typically more a person of: ',
    answers: [
      {
        letter: 'A',
        text: 'Clear reason',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Strong feeling', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you inclined more to be: ',
    answers: [
      {
        letter: 'A',
        text: 'Fair minded',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Sympathetic', answerKey: 'F' },
    ],
  },
  {
    text: 'Is it preferable mostly to: ',
    answers: [
      {
        letter: 'A',
        text: 'Make sure things are arranged',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Just let things happen', answerKey: 'P' },
    ],
  },
  {
    text: 'Is it your way more to: ',
    answers: [
      {
        letter: 'A',
        text: 'Get things settled',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Put off settlement', answerKey: 'P' },
    ],
  },
  {
    text: 'When the phone rings do you: ',
    answers: [
      {
        letter: 'A',
        text: 'Quickly get to it first',
        answerKey: 'E',
      },
      { letter: 'B', text: 'Hope someone else will answer', answerKey: 'I' },
    ],
  },
  {
    text: 'Do you prize more in yourself a: ',
    answers: [
      {
        letter: 'A',
        text: 'Good sense of reality',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Good imagination', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you drawn more to: ',
    answers: [
      {
        letter: 'A',
        text: 'Fundamentals',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Hidden meanings', answerKey: 'N' },
    ],
  },
  {
    text: 'In judging are you usually more: ',
    answers: [
      {
        letter: 'A',
        text: 'Neutral',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Charitable', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you convinced by: ',
    answers: [
      {
        letter: 'A',
        text: 'Evidence',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Someone you trust', answerKey: 'F' },
    ],
  },
  {
    text: 'Do you prefer: ',
    answers: [
      {
        letter: 'A',
        text: 'Getting something done',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Having the option to go back', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you prefer to: ',
    answers: [
      {
        letter: 'A',
        text: 'Set things up perfectly',
        answerKey: 'J',
      },
      {
        letter: 'B',
        text: 'Allow some things to just come together',
        answerKey: 'P',
      },
    ],
  },
  {
    text: 'At a networking function are you: ',
    answers: [
      {
        letter: 'A',
        text: 'Easy to approach',
        answerKey: 'E',
      },
      { letter: 'B', text: 'A little reserved', answerKey: 'I' },
    ],
  },
  {
    text: 'Do you have more fun with: ',
    answers: [
      {
        letter: 'A',
        text: 'Hands on experience',
        answerKey: 'S',
      },
      { letter: 'B', text: 'Blue sky fantasy', answerKey: 'N' },
    ],
  },
  {
    text: 'In writings do you prefer: ',
    answers: [
      {
        letter: 'A',
        text: 'The more literal',
        answerKey: 'S',
      },
      { letter: 'B', text: 'The more figurative', answerKey: 'N' },
    ],
  },
  {
    text: 'Are you usually more: ',
    answers: [
      {
        letter: 'A',
        text: 'Unbiased',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Compassionate', answerKey: 'F' },
    ],
  },
  {
    text: 'Are you typicallty more: ',
    answers: [
      {
        letter: 'A',
        text: 'Just than lenient',
        answerKey: 'T',
      },
      { letter: 'B', text: 'Lenient than just', answerKey: 'F' },
    ],
  },
  {
    text: 'Is it more like you to: ',
    answers: [
      {
        letter: 'A',
        text: 'Make snap judgements',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Delay making judgements', answerKey: 'P' },
    ],
  },
  {
    text: 'Do you tend to be more: ',
    answers: [
      {
        letter: 'A',
        text: 'Deliberate than spontaneous',
        answerKey: 'J',
      },
      { letter: 'B', text: 'Spontaneous than deliberate', answerKey: 'P' },
    ],
  },
];
